export enum UserRole {
    HR = "HR",
}